import { AppTheme, ContentType, ImageFormat, ImageOrientationType, ImageWidth } from './enums';
import { ImageEntry } from './interfaces';
import { getContentType } from './types';
import { getEnclosureLink } from './link';

export function getImageEntries(entry: any) : ImageEntry[] {
  let images: ImageEntry[] = []
  if(entry.images && entry.images.length > 0) {
    images = entry.images.map((e) => {
      return getImageEntry(e)
    })
  }
  return images
}

export function getImageEntry(entry: any) : ImageEntry | null {
  if(entry) {
    //fallback if Links are missing
    let links = entry.links ?? [];
    try {
      if(!links && entry.url?.length > 0) {
        links = entry.url.filter((urlEntry) => urlEntry.identifier == "unscaled").map((urlEntry) => {
          return {
            rel: "enclosure",
            href: urlEntry.url
          }
        });
      }
    } catch (error) {
      console.error("Error getting image entry", error);
    }
    return {
      id: entry.id ?? Math.random(),
      title: entry.title ?? null,
      type: getContentType(entry),
      credit: entry.credit ?? null,
      rate: entry.rate ?? null,
      votes: entry.votes ?? null,
      subline: entry.subline ?? null,
      alignment: entry.alignment ?? ImageOrientationType.Landscape,
      links: links
    }
  }
  return null;
}

export function getTeaserImageUrl(image: ImageEntry) : string {
  return getScaledImageUrl(image, ImageFormat.Format_16_9, ImageWidth.Width_600)
}

export function getTeaserImage4x3Url(image: ImageEntry) : string {
  return getScaledImageUrl(image, ImageFormat.Format_4_3, ImageWidth.Width_600)
}

export function getTeaserImage1x1Url(image: ImageEntry) : string {
  return getScaledImageUrl(image, ImageFormat.Format_1_1, ImageWidth.Width_600)
}

export function getInfoBoxImageUrl(image: ImageEntry) : string {
  return getScaledImageUrl(image, ImageFormat.Format_1_1, ImageWidth.Width_600)
}

function getScaledImageUrl(image: ImageEntry, format: ImageFormat, width: ImageWidth) : string {
  let unscaledUrl = getEnclosureLink(image)
  if(unscaledUrl) {
    if (process.env.NEXT_PUBLIC_IMAGE_AUTH) {
      if (unscaledUrl.includes("?")) {
        unscaledUrl += `&nbi.auth=${process.env.NEXT_PUBLIC_IMAGE_AUTH}`;
      } else {
        unscaledUrl += `?nbi.auth=${process.env.NEXT_PUBLIC_IMAGE_AUTH}`;
      }
    }

    return `${unscaledUrl}${unscaledUrl.includes("?") ? "&" : "?"}f=${encodeURIComponent(format)}&w=${width}`
  }
  return ""
}

export function getImageUrlFormat_16_9_600(image: ImageEntry) : string {
  return getScaledImageUrl(image, ImageFormat.Format_16_9, ImageWidth.Width_600)
}

export function getImageUrlFormat_9_16_600(image: ImageEntry) : string {
  return getScaledImageUrl(image, ImageFormat.Format_9_16, ImageWidth.Width_600)
}

// Large versions for the image detail view (NNBAP-514), same widths as the web.
// The image server never returns more than the original.
export function getImageUrlFormat_16_9_2400(image: ImageEntry) : string {
  return getScaledImageUrl(image, ImageFormat.Format_16_9, ImageWidth.Width_2400)
}

export function getImageUrlFormat_9_16_1000(image: ImageEntry) : string {
  return getScaledImageUrl(image, ImageFormat.Format_9_16, ImageWidth.Width_1000)
}

export function getDetailViewImageUrl(image: ImageEntry, isPortrait: boolean) : string {
  return isPortrait ? getImageUrlFormat_9_16_1000(image) : getImageUrlFormat_16_9_2400(image)
}

// export function getImageUrl600(image: ImageEntry) : string {
//   return getImageUrl(image, "600")
// }

export function getImageUrlFormat1_1_600(image: ImageEntry) : string {
  return getScaledImageUrl(image, ImageFormat.Format_1_1, ImageWidth.Width_600)
  //return getImageUrl(image, "640_640")
}

export function getImageUrlFormat1_1_500(image: ImageEntry) : string {
  return getScaledImageUrl(image, ImageFormat.Format_1_1, ImageWidth.Width_500)
}

export function getImageUrlFormat8_3_600(image: ImageEntry) : string {
  return getScaledImageUrl(image, ImageFormat.Format_8_3, ImageWidth.Width_600)
  //return getImageUrl(image, "633_768")
}

export function getImageUrlFormat2_3_600(image: ImageEntry) : string {
  return getScaledImageUrl(image, ImageFormat.Format_2_3, ImageWidth.Width_600)
  //return getImageUrl(image, "633_768")
}

export function getContentTypeIcon(type: ContentType) {
  let icons: string[] = [];
  type === ContentType.Podcast && icons.push('icon-category icon-podcast')
  type === ContentType.Gallery && icons.push('icon-category icon-slideshow')
  type === ContentType.Article && icons.push('icon-category icon-article')
  return icons
}

export function getTeaserTypeIcons(teaserTypes: string[] | undefined) {
  let icons: string[] = [];
  if(teaserTypes) {
    teaserTypes.forEach((item) => {
      switch (item) {
        case "audio":
          icons.push('icon-category icon-podcast')
          break;
        case "event":
          icons.push('icon-category icon-icon-Event')
          break;
        case "gallery":
          icons.push('icon-category icon-slideshow')
          break;
        case "gastro":
          icons.push('icon-category icon-gastro')
          break;
        case "liveticker":
          icons.push('icon-category icon-liveblog')
          break;
        case "movie":
          icons.push('icon-category icon-kino')
          break;
        case "moviedate":
          icons.push('icon-category icon-kino')
          break;
        case "dailymotionvideo":
          icons.push('icon-category icon-video')
          break;
        case "video":
          icons.push('icon-category icon-video')
          break;
        default:
          break;
      }
    })
  }
  return icons
}

export function getFallbackImageUrl() : string {
  if(process.env.NEXT_PUBLIC_APP_THEME === AppTheme.nn) {
    return "/images/fallback_img_nn.png";
  }
  return "/images/nordbayern_logo_fallback.png";
}
